import type {Options} from 'highcharts';

const axisLabels = () => ({labels: {style: {fontSize: '12px'}}});

/**
 * v1 look shared by every Highcharts mark (values follow dashboardsComponents/shared/highcharts/options).
 * A fresh object per call: the merge keeps untouched branches by reference and Highcharts may mutate them.
 */
export default function baseOptions(): Options {
    return {
        // The exporting module is loaded globally for the v1 print flow, so its menu button has to be switched off here
        exporting: {enabled: false},
        legend: {itemStyle: {fontWeight: 'normal'}},
        tooltip: {shadow: false},
        xAxis: axisLabels(),
        yAxis: axisLabels(),
        plotOptions: {
            series: {
                marker: {symbol: 'circle'},
                dataLabels: {style: {fontWeight: 'normal', fontSize: '11px'}},
            },
            column: {maxPointWidth: 50, minPointLength: 4},
            bar: {maxPointWidth: 50, minPointLength: 4},
            line: {connectNulls: true},
            spline: {connectNulls: true},
            pie: {states: {hover: {halo: {size: 0}}}},
        },
    };
}
